import { NotesInput } from "./notes-input";
import React from "react";
import "styled-components/macro";
import { ResubscribeInput } from "./resubscribe-input";
import { FareInput } from "./fare-input";
import { NumTicketsInput } from "./numTickets-input";
import { FlightNumberInput } from "./flightNumber-input";

export function BookedFormContent({
  formState,
  formActions,
  activeField,
  setActiveField,
}) {
  return (
    <>
      <div
        css={`
          display: flex;
          justify-content: space-between;
          margin-bottom: -24px;
        `}
      >
        <FareInput
          activeField={activeField}
          formState={formState}
          formActions={formActions}
          setActiveField={setActiveField}
          data_testid={"booking_form__price_input"}
          helperText={"What is the average ticket price?"}
          label={"Price"}
        />
        <NumTicketsInput
          activeField={activeField}
          formState={formState}
          formActions={formActions}
          setActiveField={setActiveField}
          data_testid={"booking_form__numTickets_input"}
          helperText={"How many tickets did you purchase?"}
          label={"Count"}
        />
      </div>
      <FlightNumberInput
        activeField={activeField}
        formState={formState}
        formActions={formActions}
        setActiveField={setActiveField}
        data_testid={"booking_form__flightNumber_input"}
        helperText={"What is your booking's carrier-prefixed flight number?"}
        label={"Flight No."}
      />
      <NotesInput
        value={formState.notes}
        onValueChange={formActions.setNotes}
        activeField={activeField}
        setActiveField={setActiveField}
      />
      <ResubscribeInput
        value={formState.resubscribe}
        onValueChange={formActions.setResubscribe}
        activeField={activeField}
        setActiveField={setActiveField}
      />
    </>
  );
}
